// extracted by mini-css-extract-plugin
export default {"chartContainer":"salesComparison_chartContainer_skYmL","light":"salesComparison_light_cFs_t","dark":"salesComparison_dark_BE5qV"};